<template>
  <div>
    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1200"
                 @check="clickCheckBox"
                 @getData="getData"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="showcaseCheckArr[props.idx]!==undefined"
          :checkedVal.sync="showcaseCheckArr[props.idx].value"></lp-check-bool>
      </div>

      <div slot="name" slot-scope="props" v-if="props.item.user">
        {{ props.item.user.name }}
      </div>

      <div slot="username" slot-scope="props" v-if="props.item.user">
        {{ props.item.user.username }}
      </div>

      <div slot="phone" slot-scope="props" v-if="props.item.user">
        {{ props.item.user.phone }}
      </div>

      <div slot="content" slot-scope="props">
        <div @click.stop.prevent="openContentModal(props.item)" style="cursor: pointer" v-if="props.item.content.length>0">
          <i class="material-icons">library_books</i>
        </div>
        <div v-else>-</div>
      </div>

      <!--<div slot="approval" slot-scope="props" style="width: 120px; margin: auto;" v-if="props.item.approval_status===0">
        <button class="button half is-primary" style="margin-right:4px" @click="clickApprovalOne('approval', props.item)">승인</button>
        <button class="button half" @click="clickApprovalOne('unapproval', props.item)">미승인</button>
      </div>-->

      <!--<div slot="spot" v-if="tableItems.length > 0">
        <div style="background-color: #eee; padding: 8px">
          <button class="button is-primary" @click="clickApproval('approval')">선택 승인</button>
          <button class="button" @click="clickApproval('unapproval')" style="margin-left:6px;">선택 미승인</button>
        </div>
      </div>-->

    </admin-table>

    <modal name="contentModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div v-for="(item, idx) in selectedContent" :key="`item-${idx}`">
          <admin-form-item :label="item.name" style="margin-top:8px">
            <img :src="item.value" v-if="isImg(item)">
            <span style="white-space: pre-line;" v-else>{{ itemValue(item) }}</span>
          </admin-form-item>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import LpCheckBool from "../../module/common/LpCheckBool";

  export default {
    name: 'PartnerApprovalAll',
    components: {LpCheckBool},
    mixins: [
      ListMixin
    ],
    data () {
      return {
        // 선택된 체크박스
        selectedContent: []
      }
    },

    created(){
      this.init();
    },
    methods: {
      init() {
        this.initializing('partner_approve_all', 'partner/approve/all');
      },
      getDataFromServer() {
        this.getData();
      },
      isImg (item) {
        let data = item.value;
        let imgExt = ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'tiff', 'tif'];
        let isImg = false;
        for(let i=0; i<imgExt.length; i++) {
          if(data.indexOf(imgExt[i])>-1) {
            isImg = true;
            break;
          }
        }
        return isImg;
      },
      itemValue(item) {
        let value = item.value;
        if(item.field==='partner.address') {
          if (typeof value === 'string') {
            return value;
          }
          else return value.new + ' ' + value.detail;
        }
        else {
          if (typeof value === 'string') {
            return value;
          } else {
            let full_text = '';
            for (let i = 0; i < value.length; i++) {
              full_text += value[i];
              if (i < value.length - 1) {
                full_text += ','
              }

            }
            return full_text;
          }
        }
      },
      openContentModal (item) {
        this.selectedContent = item.content;
        this.$modal.show('contentModal');
      },

      // 아이템 하나 선택 했을 경우
      clickApprovalOne(type, item){
        if( type === 'approval') {
          this.$axios.post(this.getUrl('partner/approve/'+item.id), {
            type: 'approval'
          }).then(res=>{
            if(res.status===200) {
              this.toast('승인 완료되었습니다');
              this.getData();
            }
          }).catch(error=>{
            if(error.response){
              this.toast(error.response.detail);
            }
          })
        }
        else if( type === 'unapproval') {
          this.$axios.post(this.getUrl('partner/approve/'+item.id), {
            type: 'unapproval'
          }).then(res=>{
            if(res.status===200) {
              this.toast('미승인 완료되었습니다');
              this.getData();
            }
          })
        }
      },

      // 체크박스로 다수 선택 하고 호출할 경우
      clickApproval(type){
        if( type === 'approval') {
          let id_list = this.getCheckedArr();
          if(id_list.length===0){
            return;
          }

          this.$axios.post(this.getUrl('partner/approve/multiple'), {
            approvals: id_list,
            type: 'approval'
          }).then(res=>{
            if(res.status===200) {
              this.toast('승인 완료되었습니다');
              this.getData();
            }
          }).catch(error=>{
            if(error.response){
              this.toast(error.response.detail);
            }
          })
        }
        else if( type === 'unapproval') {
          let id_list = this.getCheckedArr();
          if(id_list.length===0){
            return;
          }

          this.$axios.post(this.getUrl('partner/approve/multiple'), {
            approvals: id_list,
            type: 'unapproval'
          }).then(res=>{
            if(res.status===200) {
              this.toast('미승인 완료되었습니다');
              this.getData();
            }
          })
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
